import { Box, Container, Typography } from "@mui/material";
import Page from "../components/Page";

export const Politica = () => {
	return (
		<Page title="Inscripció Patum Infantil - Política de Privacitat">
			<Container maxWidth="md">
				<Box mb={10}>
					<Typography variant="h3" mb={2} style={{ color: "white" }}>
						Información completa sobre Protección de Datos
					</Typography>
					<Typography variant="h3" style={{ color: "white" }}>
						1. ¿Quién es el responsable del tratamiento de sus datos?
					</Typography>
					<Typography style={{ color: "white" }}>ASSOCIACIÓ PER LA PATUM INFANTIL</Typography>
					<Typography style={{ color: "white" }}>G64786395</Typography>
					<Typography style={{ color: "white" }}>GRAN VIA, 25 3-3 - 08600 - BERGA - BARCELONA</Typography>
					<Typography style={{ color: "white" }}>comunicacio@patuminfantil.cat</Typography>
					<Typography variant="h3" mt={3} style={{ color: "white" }}>
						2. ¿Con qué finalidad tratamos sus datos personales?
					</Typography>
					<Typography style={{ color: "white" }}>
						En ASSOCIACIÓ PER LA PATUM INFANTIL tratamos la información que nos facilitan las personas interesadas con el fin de realizar la gestión
						administrativa, contable y fiscal de los servicios solicitados, así como enviar comunicaciones promocionales sobre nuestros productos y
						servicios. En el caso de que no facilite sus datos personales, no podremos cumplir con las finalidades descritas.
					</Typography>
					<Typography style={{ color: "white" }}>No se van a tomar decisiones automatizadas en base a los datos proporcionados.</Typography>
					<Typography variant="h3" mt={3} style={{ color: "white" }}>
						3. ¿Por cuánto tiempo conservaremos sus datos?
					</Typography>
					<Typography style={{ color: "white" }}>
						Los datos se conservarán mientras el interesado no solicite su supresión, y en su caso, durante los años necesarios para cumplir con las
						obligaciones legales.
					</Typography>
					<Typography variant="h3" mt={3} style={{ color: "white" }}>
						4. ¿Cuál es la legitimación para el tratamiento de sus datos?
					</Typography>
					<Typography style={{ color: "white" }}>Le indicamos la base legal para el tratamiento de sus datos:</Typography>
					<Typography style={{ color: "white" }}>
						• Ejecución de un contrato o medidas precontractuales: Gestión de datos de las inscripciones para participar en el sorteo para la
						participación.
					</Typography>
					<Typography variant="h3" mt={3} style={{ color: "white" }}>
						5. ¿A qué destinatarios se comunicarán sus datos?
					</Typography>
					<Typography style={{ color: "white" }}>No se cederán datos a terceros, salvo obligación legal.</Typography>
					<Typography variant="h3" mt={3} style={{ color: "white" }}>
						6. Transferencias de datos a terceros países
					</Typography>
					<Typography style={{ color: "white" }}>No están previstas transferencias de datos a terceros países.</Typography>
					<Typography variant="h3" mt={3} style={{ color: "white" }}>
						7. ¿Cuáles son sus derechos cuando nos facilita sus datos?
					</Typography>
					<Typography style={{ color: "white" }}>
						Cualquier persona tiene derecho a obtener confirmación sobre si en ASSOCIACIÓ PER LA PATUM INFANTIL estamos tratando, o no, datos
						personales que les conciernan.
					</Typography>
					<Typography style={{ color: "white" }}>
						Las personas interesadas tienen derecho a acceder a sus datos personales, así como a solicitar la rectificación de los datos inexactos
						o, en su caso, solicitar su supresión cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.
						Igualmente tiene derecho a la portabilidad de sus datos.
					</Typography>
					<Typography style={{ color: "white" }}>
						En determinadas circunstancias, los interesados podrán solicitar la limitación del tratamiento de sus datos, en cuyo caso únicamente los
						conservaremos para el ejercicio o la defensa de reclamaciones.
					</Typography>
					<Typography style={{ color: "white" }}>
						En determinadas circunstancias y por motivos relacionados con su situación particular, los interesados podrán oponerse al tratamiento de
						sus datos. En este caso, ASSOCIACIÓ PER LA PATUM INFANTIL dejará de tratar los datos, salvo por motivos legítimos imperiosos, o el
						ejercicio o la defensa de posibles reclamaciones.
					</Typography>
					<Typography style={{ color: "white" }}>
						Podrá ejercitar materialmente sus derechos de la siguiente forma: dirigiéndose a comunicacio@patuminfantil.cat o Gran Via, 25 3r 3a -
						08600 - Berga - Barcelona.
					</Typography>
					<Typography style={{ color: "white" }}>
						Cuando se realice el envío de comunicaciones comerciales utilizando como base jurídica el interés legítimo del responsable, el
						interesado podrá oponerse al tratamiento de sus datos con ese fin.
					</Typography>
					<Typography style={{ color: "white" }}>
						En caso de que sienta vulnerados sus derechos en lo concerniente a la protección de sus datos personales, especialmente cuando no haya
						obtenido satisfacción en el ejercicio de sus derechos, puede presentar una reclamación ante la Autoridad de Control en materia de
						Protección de Datos competente a través de su sitio web: www.aepd.es.
					</Typography>
					<Typography variant="h3" mt={3} style={{ color: "white" }}>
						8. ¿Cómo hemos obtenido sus datos?
					</Typography>
					<Typography style={{ color: "white" }}>
						Los datos personales que tratamos en ASSOCIACIÓ PER LA PATUM INFANTIL proceden de: Del propio interesado o padres y/o tutores
					</Typography>
					<Typography style={{ color: "white" }}>
						No se tratan categorías especiales de datos personales (son aquellos datos que revelen el origen étnico o racial, las opiniones
						políticas, las convicciones religiosas o filosóficas, o la afiliación sindical, datos genéticos, datos biométricos dirigidos a
						identificar de manera unívoca a una persona física, datos relativos a la salud o datos relativos a la vida sexual o la orientación
						sexual de una persona física).
					</Typography>
				</Box>
			</Container>
		</Page>
	);
};
